import axios from "axios";
import { serverPath, getArticleHTMLBaseURL } from "config/config";
import { testArticleHTML } from "tests/testArticleHTML";

const scriptsBase = `${serverPath}/scripts`;

const endpoints = {
  list: `${scriptsBase}/getarticles.php`,
  single: `${scriptsBase}/getarticle.php`,
  create: `${scriptsBase}/savearticle.php`,
  update: `${scriptsBase}/updatearticle.php`,
  delete: `${scriptsBase}/deletearticle.php`,
};

const throwIfUnsuccessful = (response, defaultMessage) => {
  if (!response.data?.success) {
    const message =
      response.data?.message ||
      response.data?.error ||
      defaultMessage ||
      "Неизвестная ошибка";
    throw new Error(message);
  }
};

export const articleApi = {
  async fetchArticles() {
    const response = await axios.get(endpoints.list);
    throwIfUnsuccessful(response, "Не удалось получить список статей");
    return response.data.data;
  },

  async fetchArticle({ hash, userSide }) {
    const response = await axios.get(
      `${endpoints.single}?hash=${hash}&userSide=${userSide}`
    );
    throwIfUnsuccessful(response, "Не удалось загрузить статью");
    return response.data.data;
  },

  async createArticle(formData) {
    const response = await axios.post(endpoints.create, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    throwIfUnsuccessful(response, "Не удалось создать статью");
    return response.data;
  },

  async updateArticle(formData) {
    const response = await axios.post(endpoints.update, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    throwIfUnsuccessful(response, "Не удалось обновить статью");
    return response.data;
  },

  async deleteArticle(hash) {
    const response = await axios.delete(`${endpoints.delete}?hash=${hash}`);
    throwIfUnsuccessful(response, "Не удалось удалить статью");
    return hash;
  },

  async fetchArticleHTML(hash) {
    // Тестовый режим: используем локальные данные для hash "test" или "example"
    if (hash === "test" || hash === "example") {
      // Имитируем асинхронную загрузку
      await new Promise((resolve) => setTimeout(resolve, 500));
      return testArticleHTML;
    }

    const baseURL = getArticleHTMLBaseURL.replace(/\/$/, ""); // Убираем trailing slash

    try {
      // Явно используем формат /getArticle?hash={hash} (для теста и продакшена)
      const response = await axios.get(`${baseURL}/getArticle?hash=${hash}`, {
        responseType: "text",
        headers: {
          Accept: "text/html",
        },
      });
      return response.data;
    } catch (error) {
      // Пытаемся извлечь сообщение об ошибке из JSON или текста
      let message = "Не удалось загрузить HTML статью";
      if (error?.response?.data) {
        if (typeof error.response.data === "string") {
          try {
            const errorData = JSON.parse(error.response.data);
            message = errorData?.message || errorData?.error || message;
          } catch {
            message = error.response.data;
          }
        } else {
          message =
            error.response.data?.message ||
            error.response.data?.error ||
            message;
        }
      } else {
        message = error?.message || message;
      }
      throw new Error(message);
    }
  },
};


